import { devices_config } from '@devices/index';
import type { Device } from 'src/types/Device';
import { buildTopConsumers } from './energy_consumers_helpers';
import type { ConsumptionStores } from './consumption_helpers';
import { hasMonitoringDevices } from './pv_flow_helpers';

export const ENERGY_TARIFF_SETTINGS_HREF = '/cons/power_prices';
export const ENERGY_PV_SETTINGS_HREF = '/cons/pv_set_up';
export const ENERGY_ADD_DEVICE_HREF = '/home/devices/-1';

export const hasPowerMeterDevices = (devices: Record<string, Device>): boolean =>
	Object.values(devices).some((device) => device && devices_config[device.type]?.isPM);

export const hasConfiguredTariffValue = (
	settings:
		| {
				power_prices_live_tariff?: { price?: number | string } | null;
				power_prices?: string;
		  }
		| null
		| undefined,
): boolean => {
	if (Number(settings?.power_prices_live_tariff?.price ?? 0) > 0) return true;
	const raw = settings?.power_prices;
	if (!raw) return false;
	try {
		const parsed = JSON.parse(raw) as {
			tariffs?: Record<string, { price?: number | string } | null>;
		};
		return Object.values(parsed.tariffs ?? {}).some((tariff) => Number(tariff?.price ?? 0) > 0);
	} catch {
		return false;
	}
};

export const resolveConsumerDeviceIds = (
	stores: ConsumptionStores,
	devices: Record<string, Device>,
	rooms: Record<string | number, { name?: string }>,
	useDemoData: boolean,
): string[] =>
	buildTopConsumers(
		stores,
		devices,
		Math.max(Object.keys(devices).length, 1),
		'device',
		rooms,
		useDemoData,
	)
		.filter((consumer) => {
			const device = devices[consumer.id];
			return Boolean(device && !device.shared && devices_config[device.type]?.isPM);
		})
		.map((consumer) => consumer.id);

export const resolveTopConsumerDeviceId = (
	stores: ConsumptionStores,
	devices: Record<string, Device>,
	rooms: Record<string | number, { name?: string }>,
	useDemoData: boolean,
): string | undefined => resolveConsumerDeviceIds(stores, devices, rooms, useDemoData)[0];

export { hasMonitoringDevices };
